import { useEffect } from 'react';

import { theme, H1, ButtonVariant, useAuthContext } from '@catalyze/ui';
import { useManageSubscriptionMutation } from 'api/subscriptions/manageSubscription';

import { Container, StyledButton } from './styled';

export const NonPaidEmptyState = () => {
    const {
        mutate: getManageSubscriptionURL,
        data,
        isLoading,
    } = useManageSubscriptionMutation({});

    const { user } = useAuthContext();
    const { subscription } = user ?? {};

    useEffect(() => {
        getManageSubscriptionURL();
    }, [getManageSubscriptionURL]);

    const handleManageSubsClick = () => {
        if (!subscription) {
            window.location.href = '/subscription';
        } else {
            // user can cancel plan so we neeed to reset these queries
            window.location.href = data?.redirectUrl || '';
        }
    };

    return (
        <Container>
            <H1>Upgrade your subscription to access this information</H1>
            {!isLoading && (
                <StyledButton
                    variant={ButtonVariant.SECONDARY}
                    color={theme.colors.bgPrimary}
                    bgColor={theme.colors.closed}
                    onClick={handleManageSubsClick}
                >
                    Manage Subscriptions
                </StyledButton>
            )}
        </Container>
    );
};
